import { ImageElement } from "components/UiElement";
import { useState } from "react";
import { Container } from "react-bootstrap";
import { dayJsDateFormatter, getLocation } from "utils";

function BannerSection03({ memorialData, name }) {
  const [hoveredItem, setHoveredItem] = useState(2);

  const handleMouseEnter = (index) => {
    setHoveredItem(index);
  };

  const handleMouseLeave = (index) => {
    if (hoveredItem === index) {
      setHoveredItem(null);
    }
  };
  return (
    <>
      <div className="banner position-relative overflow-hidden">
        <div className="banner_inner">
          <Container>
            <div className="head text-center">
              <h1 className="text-white text-break">{name}</h1>
              {memorialData?.birthDate && (
                <p>
                  {dayJsDateFormatter(memorialData?.birthDate, "MMM DD, YYYY")}
                  {memorialData?.deathDate &&
                    dayJsDateFormatter(
                      memorialData?.deathDate,
                      "MMM DD, YYYY"
                    )}
                </p>
              )}
              {memorialData?.location && (
                <p>
                  <em className="icon-location me-2" />
                  {getLocation(memorialData?.location)}
                </p>
              )}
            </div>
          </Container>
          <div className="imageList">
            <ul className="list-unstyled mb-0 d-flex justify-content-center">
              {memorialData?.themeOnes?.length > 0 &&
                memorialData?.themeOnes?.map((item, index) => (
                  <li key={index}>
                    <div className="w-100 h-100">
                      <ImageElement
                        className={`img-fluid w-100 ${
                          hoveredItem === index ? "active" : ""
                        }`}
                        previewSource={item?.coverImageUrl}
                        alt={item.alt}
                        onMouseEnter={() => handleMouseEnter(index)}
                        onMouseLeave={handleMouseLeave}
                      />
                    </div>
                  </li>
                ))}
            </ul>
          </div>
          <div className="py-80 pt-0 circle">
            <Container>
              <div className="banner_bottom text-center">
                <h2 className="text-uppercase">
                  Celebration of <br className="d-none d-lg-block" />
                  Life <span className="d-block" />
                </h2>
                <p className="mb-0">{memorialData?.myBio}</p>
                {/* <div className="d-flex justify-content-center">
                      <RippleEffect>
                        <Button className="btn btn-gradiant btnDownload">
                          <em className="icon-download" />
                          <span className="d-none d-sm-block">Download</span>
                        </Button>
                      </RippleEffect>
                    </div> */}
              </div>
            </Container>
          </div>
        </div>
      </div>
    </>
  );
}

export default BannerSection03;
